import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { CloudRain } from "lucide-react";
import { api } from "@/lib/api";

/** "It rained in the sleep garden" — shown this week in every category the member joined where half+ of challengers finished. */
export function RainDayBanner({ category = null, compact = false }) {
  const [days, setDays] = useState([]);
  useEffect(() => {
    api.get("/community/rain-days").then((r) => setDays(r.data.rain_days)).catch(() => {});
  }, []);
  const shown = days.filter((d) => (category ? d.category === category : true));
  if (!shown.length) return null;
  return (
    <div className="space-y-2" data-testid="rain-day-banner">
      {shown.map((d) => (
        <motion.div key={d.id} initial={{ opacity: 0, y: -6 }} animate={{ opacity: 1, y: 0 }}
          className={`relative overflow-hidden rounded-2xl border border-sky-200 bg-gradient-to-r from-sky-50 via-cyan-50 to-sky-100 ${compact ? "p-3" : "p-4"}`} data-testid={`rain-day-${d.category}`}>
          <div className="absolute inset-0 pointer-events-none" aria-hidden>
            {Array.from({ length: 14 }).map((_, i) => (
              <motion.span key={i} className="absolute top-0 w-px h-3 bg-sky-300/70 rounded-full" style={{ left: `${4 + i * 7}%` }}
                animate={{ y: ["-20%", "140%"], opacity: [0, 0.9, 0] }} transition={{ duration: 1.4 + (i % 3) * 0.3, repeat: Infinity, delay: (i % 5) * 0.25, ease: "linear" }} />
            ))}
          </div>
          <div className="relative flex items-center gap-3 flex-wrap">
            <div className="w-9 h-9 rounded-xl bg-white/80 flex items-center justify-center shrink-0"><CloudRain className="w-5 h-5 text-sky-700" /></div>
            <div className="min-w-0 flex-1">
              <div className="text-[10px] font-bold uppercase tracking-widest text-sky-800">Rain Day · {d.today ? "today" : d.date}</div>
              <div className="font-display text-base md:text-lg font-bold text-stone-900">It rained in the <span className="capitalize">{d.category}</span> garden</div>
              <p className="text-xs text-stone-600">{d.finishers} of {d.participants} finished this week's challenge, so everyone who joined got a shower{d.mine ? <> — <strong className="text-sky-800">+{d.points} pts for you</strong></> : ""}.</p>
            </div>
          </div>
        </motion.div>
      ))}
    </div>
  );
}
